"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapPageElement = exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var wrapRootElement = function wrapRootElement(_ref, pluginOptions) {
  var element = _ref.element;
  return /*#__PURE__*/_react["default"].createElement(_.AnalyticsProvider, {
    siteData: pluginOptions.config.siteData
  }, element);
};

exports.wrapRootElement = wrapRootElement;

var wrapPageElement = function wrapPageElement(_ref2, pluginOptions) {
  var element = _ref2.element,
      props = _ref2.props;
  return /*#__PURE__*/_react["default"].createElement(_.PageTracking, _extends({
    exceptions: pluginOptions.config.pageDataExceptions
  }, props), element);
};

exports.wrapPageElement = wrapPageElement;